import { useState, useEffect } from 'react';

// scroll object: {pos, scrollDown}

const useScroll = () => {
    const [scrollObject, setScrollObject] = useState({position: 0, scrollDown: false});
  
    useEffect(() => {
      const updateScroll = () => {
        setScrollObject((prevScrollObject) => {
            return {position: window.scrollY, scrollUp: prevScrollObject.position >= window.scrollY}
        });
      }
      window.addEventListener("scroll", updateScroll);
      updateScroll();
      return () => window.removeEventListener("scroll", updateScroll);
    }, []);
  
    return scrollObject;
  };
  
  export default useScroll;